import { Injectable } from '@angular/core';
import { ApplicationApiService } from '../../shared/rest/application-api.service';
import { Application } from 'src/app/shared/models/Application.model';

@Injectable({
  providedIn: 'root'
})
export class ApplicationService {
  constructor(private applicationApiService: ApplicationApiService) {}

  getApplications() {
    return this.applicationApiService.getApplications();
  }

  getFilesById(id: string) {
    return this.applicationApiService.getFilesById(id);
  }
  applicationToJSON(application: Application) {
    return this.applicationApiService.applicationToJSON(application);
  }

  updateApplication(application: Application) {
    return this.applicationApiService
      .updateApplicationById(application)
      .subscribe();
  }

  addApplicationFiles(files: any) {
    return this.applicationApiService.addApplicationFiles(files).subscribe();
  }

  mailDeclinedApplications(year: string) {
    return this.applicationApiService.mailDeclineApplications(year).subscribe();
  }
}
